import { useState } from 'react'
import { router, Link, usePage } from '@inertiajs/react'
import Layout from '../Layout'

export default function New() {
  const { props } = usePage()
  const alert = props.flash?.alert

  const [name, setName] = useState('')
  const [submitting, setSubmitting] = useState(false)

  function handleSubmit(e) {
    e.preventDefault()
    setSubmitting(true)
    router.post('/settings/workspaces', { name }, {
      onFinish: () => setSubmitting(false),
    })
  }

  return (
    <Layout active="workspaces">
      <div className="max-w-md">
        <h2 className="text-sm font-mono font-bold text-zinc-300 mb-6">
          Create workspace
        </h2>

        {alert && (
          <div className="mb-4 px-4 py-2 bg-red-950 border border-red-800 rounded text-sm text-red-400 font-mono">
            {alert}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-xs font-mono text-zinc-400 mb-1">
              NAME
            </label>
            <input
              type="text"
              value={name}
              onChange={e => setName(e.target.value)}
              className="w-full bg-zinc-800 border border-zinc-700 rounded px-3 py-2 text-sm font-mono text-zinc-100 placeholder-zinc-600 focus:outline-none focus:ring-1 focus:ring-emerald-500 focus:border-emerald-500"
              placeholder="my-workspace"
              required
              autoFocus
            />
          </div>

          <div className="flex items-center gap-3">
            <button
              type="submit"
              disabled={submitting}
              className="bg-emerald-600 hover:bg-emerald-500 disabled:opacity-50 disabled:cursor-not-allowed text-white font-mono text-sm font-medium py-2 px-4 rounded transition-colors"
            >
              {submitting ? 'Creating...' : 'Create workspace'}
            </button>
            <Link
              href="/settings/users"
              className="text-xs font-mono text-zinc-500 hover:text-zinc-300 transition-colors"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </Layout>
  )
}
